import axios, { getData } from "lib/axios"

export const eduProgress = async (id) => {
  return axios.get(`/job_seekers/edu_my_progress/${id}`).then(getData)
}
